var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 16.286,
    viewBox: "0 0 14.857 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 14.857,
    height: 16.286,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3122",
    "data-name": "Group 3122",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M10.714,14.656H8.429a.8.8,0,0,1-.8-.8V9.349H5.8v4.508a.8.8,0,0,1-.8.8H2.714A2.546,2.546,0,0,1,.2,12.086V5.616a2.009,2.009,0,0,1,.811-1.611l.007,0L5.92.457a1.355,1.355,0,0,1,1.589,0L12.411,4l.007,0a2.009,2.009,0,0,1,.811,1.611v6.47A2.546,2.546,0,0,1,10.714,14.656Zm-1.486-1.6h1.486a.945.945,0,0,0,.914-.971V5.616a.4.4,0,0,0-.159-.322L6.714,1.857,1.959,5.294a.4.4,0,0,0-.159.322v6.47a.945.945,0,0,0,.914.971H4.2V8.549a.8.8,0,0,1,.8-.8H8.429a.8.8,0,0,1,.8.8Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_155",
    "data-name": "Line 155",
    d: "M3.429.8H0A.8.8,0,0,1-.8,0,.8.8,0,0,1,0-.8H3.429a.8.8,0,0,1,.8.8A.8.8,0,0,1,3.429.8Z",
    transform: "translate(4.714 13.571)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bd61f3828c4d5830a7fe033b54a62ab6.svg";
export { ForwardRef as ReactComponent };